/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CurrencyCode,
    CurrencyCodeFromJSON,
    CurrencyCodeToJSON,
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetManyOrder,
    GetManyOrderFromJSON,
    GetManyOrderToJSON,
    Order,
    OrderFromJSON,
    OrderToJSON,
    OrderCreateParams,
    OrderCreateParamsFromJSON,
    OrderCreateParamsToJSON,
    OrderCreateParamsV2,
    OrderCreateParamsV2FromJSON,
    OrderCreateParamsV2ToJSON,
    OrderExpandableType,
    OrderExpandableTypeFromJSON,
    OrderExpandableTypeToJSON,
    OrderItem,
    OrderItemFromJSON,
    OrderItemToJSON,
    OrderItemCreateParams,
    OrderItemCreateParamsFromJSON,
    OrderItemCreateParamsToJSON,
    OrderItemCreateParamsV2,
    OrderItemCreateParamsV2FromJSON,
    OrderItemCreateParamsV2ToJSON,
    OrderItemExpandableType,
    OrderItemExpandableTypeFromJSON,
    OrderItemExpandableTypeToJSON,
    OrderItemList,
    OrderItemListFromJSON,
    OrderItemListToJSON,
    OrderItemListV2,
    OrderItemListV2FromJSON,
    OrderItemListV2ToJSON,
    OrderItemType,
    OrderItemTypeFromJSON,
    OrderItemTypeToJSON,
    OrderItemUpdateParams,
    OrderItemUpdateParamsFromJSON,
    OrderItemUpdateParamsToJSON,
    OrderItemUpdateParamsV2,
    OrderItemUpdateParamsV2FromJSON,
    OrderItemUpdateParamsV2ToJSON,
    OrderItemV2,
    OrderItemV2FromJSON,
    OrderItemV2ToJSON,
    OrderList,
    OrderListFromJSON,
    OrderListToJSON,
    OrderListV2,
    OrderListV2FromJSON,
    OrderListV2ToJSON,
    OrderQuoteParams,
    OrderQuoteParamsFromJSON,
    OrderQuoteParamsToJSON,
    OrderStatus,
    OrderStatusFromJSON,
    OrderStatusToJSON,
    OrderUpdateParams,
    OrderUpdateParamsFromJSON,
    OrderUpdateParamsToJSON,
    OrderV2,
    OrderV2FromJSON,
    OrderV2ToJSON,
    PaymentList,
    PaymentListFromJSON,
    PaymentListToJSON,
    PaymentMethod,
    PaymentMethodFromJSON,
    PaymentMethodToJSON,
    PaymentResult,
    PaymentResultFromJSON,
    PaymentResultToJSON,
    PaymentResultV2,
    PaymentResultV2FromJSON,
    PaymentResultV2ToJSON,
    ProcessPaymentParams,
    ProcessPaymentParamsFromJSON,
    ProcessPaymentParamsToJSON,
    Refund,
    RefundFromJSON,
    RefundToJSON,
    RefundCreateParams,
    RefundCreateParamsFromJSON,
    RefundCreateParamsToJSON,
    RefundCreateParamsV2,
    RefundCreateParamsV2FromJSON,
    RefundCreateParamsV2ToJSON,
    RefundList,
    RefundListFromJSON,
    RefundListToJSON,
    RefundListV2,
    RefundListV2FromJSON,
    RefundListV2ToJSON,
    RefundResultV2,
    RefundResultV2FromJSON,
    RefundResultV2ToJSON,
    RefundUpdateParams,
    RefundUpdateParamsFromJSON,
    RefundUpdateParamsToJSON,
    RefundUpdateParamsV2,
    RefundUpdateParamsV2FromJSON,
    RefundUpdateParamsV2ToJSON,
    RefundV2,
    RefundV2FromJSON,
    RefundV2ToJSON,
    RegistrationList,
    RegistrationListFromJSON,
    RegistrationListToJSON,
    RegistrationStatus,
    RegistrationStatusFromJSON,
    RegistrationStatusToJSON,
    SuccessResponse,
    SuccessResponseFromJSON,
    SuccessResponseToJSON,
} from '../models';

export interface CancelOrderRequest {
    program_id: string;
    order_id: string;
}

export interface CancelOrderV2Request {
    program_id: string;
    order_id: string;
}

export interface ConfirmPaymentRequest {
    program_id: string;
    order_id: string;
    id: string;
}

export interface ConfirmPaymentV2Request {
    program_id: string;
    order_id: string;
    id: string;
}

export interface CreateOrderRequest {
    program_id: string;
    OrderCreateParams: OrderCreateParams;
}

export interface CreateOrderItemRequest {
    program_id: string;
    order_id: string;
    OrderItemCreateParams: OrderItemCreateParams;
}

export interface CreateOrderItemV2Request {
    program_id: string;
    order_id: string;
    OrderItemCreateParamsV2: OrderItemCreateParamsV2;
}

export interface CreateOrderV2Request {
    program_id: string;
    OrderCreateParamsV2: OrderCreateParamsV2;
}

export interface CreateQuoteOrderV2Request {
    program_id: string;
    order_id: string;
    OrderQuoteParams: OrderQuoteParams;
}

export interface CreateRefundV2Request {
    program_id: string;
    order_id: string;
    RefundCreateParamsV2: RefundCreateParamsV2;
}

export interface DeleteOrderRequest {
    program_id: string;
    order_id: string;
}

export interface DeleteOrderItemRequest {
    program_id: string;
    order_id: string;
    id: string;
}

export interface DeleteOrderItemV2Request {
    program_id: string;
    order_id: string;
    id: string;
}

export interface DeleteOrderV2Request {
    program_id: string;
    order_id: string;
}

export interface FindOneOrderRequest {
    program_id: string;
    order_id: string;
    expand?: Array<OrderExpandableType>;
}

export interface FindOneOrderItemRequest {
    program_id: string;
    order_id: string;
    id: string;
}

export interface FindOneOrderItemV2Request {
    program_id: string;
    order_id: string;
    id: string;
}

export interface FindOneOrderV2Request {
    program_id: string;
    order_id: string;
}

export interface FindOneRefundRequest {
    program_id: string;
    refund_id: string;
}

export interface FindOneRefundV2Request {
    program_id: string;
    order_id: string;
    id: string;
}

export interface FindOneRegistrationsOrderRequest {
    program_id: string;
    order_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    status?: Array<RegistrationStatus>;
}

export interface FindOrderItemsRequest {
    program_id: string;
    order_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    expand?: Array<OrderItemExpandableType>;
}

export interface FindOrderItemsV2Request {
    program_id: string;
    order_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    id?: Array<string>;
}

export interface FindOrdersRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    status?: Array<OrderStatus>;
    checkout_method?: Array<PaymentMethod>;
    contact_id?: string;
    item_type?: Array<OrderItemType>;
    partially_paid?: boolean;
    item_parent?: Array<string>;
    coupon?: Array<string>;
    amount_total_lt?: number;
    amount_total_gt?: number;
    amount_total_lte?: number;
    amount_total_gte?: number;
    created_lt?: Date;
    created_gt?: Date;
    created_lte?: Date;
    created_gte?: Date;
    updated_lt?: Date;
    updated_gt?: Date;
    updated_lte?: Date;
    updated_gte?: Date;
    processed_lt?: Date;
    processed_gt?: Date;
    processed_lte?: Date;
    processed_gte?: Date;
}

export interface FindOrdersV2Request {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    id?: Array<string>;
    exclude_id?: Array<string>;
    status?: Array<OrderStatus>;
    checkout_method?: Array<PaymentMethod>;
    membership_id?: string;
    contact_id?: string;
    product_id?: Array<string>;
    product_category_id?: Array<string>;
    parent_id?: Array<string>;
    partially_paid?: boolean;
    coupon_id?: Array<string>;
    amount_total_lt?: number;
    amount_total_gt?: number;
    amount_total_lte?: number;
    amount_total_gte?: number;
    created_lt?: Date;
    created_gt?: Date;
    created_lte?: Date;
    created_gte?: Date;
    updated_lt?: Date;
    updated_gt?: Date;
    updated_lte?: Date;
    updated_gte?: Date;
    processed_lt?: Date;
    processed_gt?: Date;
    processed_lte?: Date;
    processed_gte?: Date;
}

export interface FindPaymentsRequest {
    program_id: string;
    order_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
}

export interface FindPaymentsV2Request {
    program_id: string;
    order_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
}

export interface FindQuoteOrderRequest {
    program_id: string;
    order_id: string;
    use_account_balance?: boolean;
    checkout_method?: PaymentMethod;
    currency?: CurrencyCode;
    country?: string;
    expand?: Array<OrderExpandableType>;
}

export interface FindRefundsRequest {
    program_id: string;
    order_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    created_lt?: Date;
    created_gt?: Date;
    created_lte?: Date;
    created_gte?: Date;
    updated_lt?: Date;
    updated_gt?: Date;
    updated_lte?: Date;
    updated_gte?: Date;
}

export interface FindRefundsV2Request {
    program_id: string;
    order_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    id?: Array<string>;
}

export interface ProcessPaymentRequest {
    program_id: string;
    order_id: string;
    ProcessPaymentParams: ProcessPaymentParams;
}

export interface ProcessPaymentV2Request {
    program_id: string;
    order_id: string;
    ProcessPaymentParams: ProcessPaymentParams;
}

export interface RefundRefundRequest {
    program_id: string;
    order_id: string;
    RefundCreateParams: RefundCreateParams;
}

export interface ResendOrderRequest {
    program_id: string;
    order_id: string;
}

export interface ResendOrderV2Request {
    program_id: string;
    order_id: string;
}

export interface UpdateOrderRequest {
    program_id: string;
    order_id: string;
    Order: Order;
}

export interface UpdateOrderItemRequest {
    program_id: string;
    order_id: string;
    id: string;
    OrderItemUpdateParams: OrderItemUpdateParams;
}

export interface UpdateOrderItemV2Request {
    program_id: string;
    order_id: string;
    id: string;
    OrderItemUpdateParamsV2: OrderItemUpdateParamsV2;
}

export interface UpdateOrderV2Request {
    program_id: string;
    order_id: string;
    OrderUpdateParams: OrderUpdateParams;
}

export interface UpdateRefundRequest {
    program_id: string;
    refund_id: string;
    RefundUpdateParams: RefundUpdateParams;
}

export interface UpdateRefundV2Request {
    program_id: string;
    order_id: string;
    id: string;
    RefundUpdateParamsV2: RefundUpdateParamsV2;
}

/**
 * 
 */
export class OrdersApi extends runtime.BaseAPI {

    /**
     * @deprecated Cancel an order
     */
    async cancelOrderRaw(requestParameters: CancelOrderRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Order>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling cancelOrder.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling cancelOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/orders/{order_id}/cancel`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderFromJSON(jsonValue));
    }

    /**
     * @deprecated Cancel an order
     */
    async cancelOrder(requestParameters: CancelOrderRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Order> {
        const response = await this.cancelOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancel an order
     */
    async cancelOrderV2Raw(requestParameters: CancelOrderV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<OrderV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling cancelOrderV2.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling cancelOrderV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/orders/{order_id}/cancel`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderV2FromJSON(jsonValue));
    }

    /**
     * Cancel an order
     */
    async cancelOrderV2(requestParameters: CancelOrderV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<OrderV2> {
        const response = await this.cancelOrderV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Confirm payment by id
     */
    async confirmPaymentRaw(requestParameters: ConfirmPaymentRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<PaymentResult>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling confirmPayment.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling confirmPayment.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling confirmPayment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/orders/{order_id}/payments/payments/{id}/confirm`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentResultFromJSON(jsonValue));
    }

    /**
     * Confirm payment by id
     */
    async confirmPayment(requestParameters: ConfirmPaymentRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<PaymentResult> {
        const response = await this.confirmPaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Confirm payment by id
     */
    async confirmPaymentV2Raw(requestParameters: ConfirmPaymentV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<PaymentResultV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling confirmPaymentV2.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling confirmPaymentV2.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling confirmPaymentV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/orders/{order_id}/payments/payments/{id}/confirm`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentResultV2FromJSON(jsonValue));
    }

    /**
     * Confirm payment by id
     */
    async confirmPaymentV2(requestParameters: ConfirmPaymentV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<PaymentResultV2> {
        const response = await this.confirmPaymentV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Create order
     */
    async createOrderRaw(requestParameters: CreateOrderRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Order>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createOrder.');
        }

        if (requestParameters.OrderCreateParams === null || requestParameters.OrderCreateParams === undefined) {
            throw new runtime.RequiredError('OrderCreateParams','Required parameter requestParameters.OrderCreateParams was null or undefined when calling createOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/orders`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderCreateParamsToJSON(requestParameters.OrderCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderFromJSON(jsonValue));
    }

    /**
     * @deprecated Create order
     */
    async createOrder(requestParameters: CreateOrderRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Order> {
        const response = await this.createOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Create order item
     */
    async createOrderItemRaw(requestParameters: CreateOrderItemRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<OrderItem>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createOrderItem.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling createOrderItem.');
        }

        if (requestParameters.OrderItemCreateParams === null || requestParameters.OrderItemCreateParams === undefined) {
            throw new runtime.RequiredError('OrderItemCreateParams','Required parameter requestParameters.OrderItemCreateParams was null or undefined when calling createOrderItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/orders/{order_id}/items`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderItemCreateParamsToJSON(requestParameters.OrderItemCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderItemFromJSON(jsonValue));
    }

    /**
     * @deprecated Create order item
     */
    async createOrderItem(requestParameters: CreateOrderItemRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<OrderItem> {
        const response = await this.createOrderItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create order item
     */
    async createOrderItemV2Raw(requestParameters: CreateOrderItemV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<OrderItemV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createOrderItemV2.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling createOrderItemV2.');
        }

        if (requestParameters.OrderItemCreateParamsV2 === null || requestParameters.OrderItemCreateParamsV2 === undefined) {
            throw new runtime.RequiredError('OrderItemCreateParamsV2','Required parameter requestParameters.OrderItemCreateParamsV2 was null or undefined when calling createOrderItemV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/orders/{order_id}/items`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderItemCreateParamsV2ToJSON(requestParameters.OrderItemCreateParamsV2),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderItemV2FromJSON(jsonValue));
    }

    /**
     * Create order item
     */
    async createOrderItemV2(requestParameters: CreateOrderItemV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<OrderItemV2> {
        const response = await this.createOrderItemV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create order
     */
    async createOrderV2Raw(requestParameters: CreateOrderV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<OrderV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createOrderV2.');
        }

        if (requestParameters.OrderCreateParamsV2 === null || requestParameters.OrderCreateParamsV2 === undefined) {
            throw new runtime.RequiredError('OrderCreateParamsV2','Required parameter requestParameters.OrderCreateParamsV2 was null or undefined when calling createOrderV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/orders`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderCreateParamsV2ToJSON(requestParameters.OrderCreateParamsV2),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderV2FromJSON(jsonValue));
    }

    /**
     * Create order
     */
    async createOrderV2(requestParameters: CreateOrderV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<OrderV2> {
        const response = await this.createOrderV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create order quote
     */
    async createQuoteOrderV2Raw(requestParameters: CreateQuoteOrderV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<OrderV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createQuoteOrderV2.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling createQuoteOrderV2.');
        }

        if (requestParameters.OrderQuoteParams === null || requestParameters.OrderQuoteParams === undefined) {
            throw new runtime.RequiredError('OrderQuoteParams','Required parameter requestParameters.OrderQuoteParams was null or undefined when calling createQuoteOrderV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/orders/{order_id}/quote`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderQuoteParamsToJSON(requestParameters.OrderQuoteParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderV2FromJSON(jsonValue));
    }

    /**
     * Create order quote
     */
    async createQuoteOrderV2(requestParameters: CreateQuoteOrderV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<OrderV2> {
        const response = await this.createQuoteOrderV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create refund
     */
    async createRefundV2Raw(requestParameters: CreateRefundV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<RefundResultV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createRefundV2.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling createRefundV2.');
        }

        if (requestParameters.RefundCreateParamsV2 === null || requestParameters.RefundCreateParamsV2 === undefined) {
            throw new runtime.RequiredError('RefundCreateParamsV2','Required parameter requestParameters.RefundCreateParamsV2 was null or undefined when calling createRefundV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/orders/{order_id}/refunds`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RefundCreateParamsV2ToJSON(requestParameters.RefundCreateParamsV2),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RefundResultV2FromJSON(jsonValue));
    }

    /**
     * Create refund
     */
    async createRefundV2(requestParameters: CreateRefundV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<RefundResultV2> {
        const response = await this.createRefundV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Delete order
     */
    async deleteOrderRaw(requestParameters: DeleteOrderRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling deleteOrder.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling deleteOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/orders/{order_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * @deprecated Delete order
     */
    async deleteOrder(requestParameters: DeleteOrderRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.deleteOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Delete order item
     */
    async deleteOrderItemRaw(requestParameters: DeleteOrderItemRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling deleteOrderItem.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling deleteOrderItem.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteOrderItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/orders/{order_id}/items/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * @deprecated Delete order item
     */
    async deleteOrderItem(requestParameters: DeleteOrderItemRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.deleteOrderItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete order item
     */
    async deleteOrderItemV2Raw(requestParameters: DeleteOrderItemV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling deleteOrderItemV2.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling deleteOrderItemV2.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteOrderItemV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/orders/{order_id}/items/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Delete order item
     */
    async deleteOrderItemV2(requestParameters: DeleteOrderItemV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.deleteOrderItemV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete order
     */
    async deleteOrderV2Raw(requestParameters: DeleteOrderV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling deleteOrderV2.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling deleteOrderV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/orders/{order_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Delete order
     */
    async deleteOrderV2(requestParameters: DeleteOrderV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.deleteOrderV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Find order by id
     */
    async findOneOrderRaw(requestParameters: FindOneOrderRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Order>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneOrder.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling findOneOrder.');
        }

        const queryParameters: any = {};

        if (requestParameters.expand) {
            queryParameters['expand'] = requestParameters.expand;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/orders/{order_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderFromJSON(jsonValue));
    }

    /**
     * @deprecated Find order by id
     */
    async findOneOrder(requestParameters: FindOneOrderRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Order> {
        const response = await this.findOneOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Find order item by id
     */
    async findOneOrderItemRaw(requestParameters: FindOneOrderItemRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<OrderItem>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneOrderItem.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling findOneOrderItem.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findOneOrderItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/orders/{order_id}/items/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderItemFromJSON(jsonValue));
    }

    /**
     * @deprecated Find order item by id
     */
    async findOneOrderItem(requestParameters: FindOneOrderItemRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<OrderItem> {
        const response = await this.findOneOrderItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find order item by id
     */
    async findOneOrderItemV2Raw(requestParameters: FindOneOrderItemV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<OrderItemV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneOrderItemV2.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling findOneOrderItemV2.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findOneOrderItemV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/orders/{order_id}/items/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderItemV2FromJSON(jsonValue));
    }

    /**
     * Find order item by id
     */
    async findOneOrderItemV2(requestParameters: FindOneOrderItemV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<OrderItemV2> {
        const response = await this.findOneOrderItemV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find order by id
     */
    async findOneOrderV2Raw(requestParameters: FindOneOrderV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<OrderV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneOrderV2.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling findOneOrderV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/orders/{order_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderV2FromJSON(jsonValue));
    }

    /**
     * Find order by id
     */
    async findOneOrderV2(requestParameters: FindOneOrderV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<OrderV2> {
        const response = await this.findOneOrderV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Find refund by id
     */
    async findOneRefundRaw(requestParameters: FindOneRefundRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Refund>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneRefund.');
        }

        if (requestParameters.refund_id === null || requestParameters.refund_id === undefined) {
            throw new runtime.RequiredError('refund_id','Required parameter requestParameters.refund_id was null or undefined when calling findOneRefund.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/orders/{order_id}/refunds/{refund_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"refund_id"}}`, encodeURIComponent(String(requestParameters.refund_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RefundFromJSON(jsonValue));
    }

    /**
     * @deprecated Find refund by id
     */
    async findOneRefund(requestParameters: FindOneRefundRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Refund> {
        const response = await this.findOneRefundRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find refund by id
     */
    async findOneRefundV2Raw(requestParameters: FindOneRefundV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<RefundV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneRefundV2.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling findOneRefundV2.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findOneRefundV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/orders/{order_id}/refunds/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RefundV2FromJSON(jsonValue));
    }

    /**
     * Find refund by id
     */
    async findOneRefundV2(requestParameters: FindOneRefundV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<RefundV2> {
        const response = await this.findOneRefundV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated List all registration for order
     */
    async findOneRegistrationsOrderRaw(requestParameters: FindOneRegistrationsOrderRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<RegistrationList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneRegistrationsOrder.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling findOneRegistrationsOrder.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/orders/{order_id}/registrations`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationListFromJSON(jsonValue));
    }

    /**
     * @deprecated List all registration for order
     */
    async findOneRegistrationsOrder(requestParameters: FindOneRegistrationsOrderRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<RegistrationList> {
        const response = await this.findOneRegistrationsOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated List all order item
     */
    async findOrderItemsRaw(requestParameters: FindOrderItemsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<OrderItemList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOrderItems.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling findOrderItems.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.expand) {
            queryParameters['expand'] = requestParameters.expand;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/orders/{order_id}/items`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderItemListFromJSON(jsonValue));
    }

    /**
     * @deprecated List all order item
     */
    async findOrderItems(requestParameters: FindOrderItemsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<OrderItemList> {
        const response = await this.findOrderItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all order items
     */
    async findOrderItemsV2Raw(requestParameters: FindOrderItemsV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<OrderItemListV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOrderItemsV2.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling findOrderItemsV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/orders/{order_id}/items`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderItemListV2FromJSON(jsonValue));
    }

    /**
     * List all order items
     */
    async findOrderItemsV2(requestParameters: FindOrderItemsV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<OrderItemListV2> {
        const response = await this.findOrderItemsV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated List all orders
     */
    async findOrdersRaw(requestParameters: FindOrdersRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<OrderList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOrders.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.checkout_method) {
            queryParameters['checkout_method'] = requestParameters.checkout_method;
        }

        if (requestParameters.contact_id !== undefined) {
            queryParameters['contact_id'] = requestParameters.contact_id;
        }

        if (requestParameters.item_type) {
            queryParameters['item_type'] = requestParameters.item_type;
        }

        if (requestParameters.partially_paid !== undefined) {
            queryParameters['partially_paid'] = requestParameters.partially_paid;
        }

        if (requestParameters.item_parent) {
            queryParameters['item_parent'] = requestParameters.item_parent;
        }

        if (requestParameters.coupon) {
            queryParameters['coupon'] = requestParameters.coupon;
        }

        if (requestParameters.amount_total_lt !== undefined) {
            queryParameters['amount_total_lt'] = requestParameters.amount_total_lt;
        }

        if (requestParameters.amount_total_gt !== undefined) {
            queryParameters['amount_total_gt'] = requestParameters.amount_total_gt;
        }

        if (requestParameters.amount_total_lte !== undefined) {
            queryParameters['amount_total_lte'] = requestParameters.amount_total_lte;
        }

        if (requestParameters.amount_total_gte !== undefined) {
            queryParameters['amount_total_gte'] = requestParameters.amount_total_gte;
        }

        if (requestParameters.created_lt !== undefined) {
            queryParameters['created_lt'] = (requestParameters.created_lt as any).toISOString();
        }

        if (requestParameters.created_gt !== undefined) {
            queryParameters['created_gt'] = (requestParameters.created_gt as any).toISOString();
        }

        if (requestParameters.created_lte !== undefined) {
            queryParameters['created_lte'] = (requestParameters.created_lte as any).toISOString();
        }

        if (requestParameters.created_gte !== undefined) {
            queryParameters['created_gte'] = (requestParameters.created_gte as any).toISOString();
        }

        if (requestParameters.updated_lt !== undefined) {
            queryParameters['updated_lt'] = (requestParameters.updated_lt as any).toISOString();
        }

        if (requestParameters.updated_gt !== undefined) {
            queryParameters['updated_gt'] = (requestParameters.updated_gt as any).toISOString();
        }

        if (requestParameters.updated_lte !== undefined) {
            queryParameters['updated_lte'] = (requestParameters.updated_lte as any).toISOString();
        }

        if (requestParameters.updated_gte !== undefined) {
            queryParameters['updated_gte'] = (requestParameters.updated_gte as any).toISOString();
        }

        if (requestParameters.processed_lt !== undefined) {
            queryParameters['processed_lt'] = (requestParameters.processed_lt as any).toISOString();
        }

        if (requestParameters.processed_gt !== undefined) {
            queryParameters['processed_gt'] = (requestParameters.processed_gt as any).toISOString();
        }

        if (requestParameters.processed_lte !== undefined) {
            queryParameters['processed_lte'] = (requestParameters.processed_lte as any).toISOString();
        }

        if (requestParameters.processed_gte !== undefined) {
            queryParameters['processed_gte'] = (requestParameters.processed_gte as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/orders`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderListFromJSON(jsonValue));
    }

    /**
     * @deprecated List all orders
     */
    async findOrders(requestParameters: FindOrdersRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<OrderList> {
        const response = await this.findOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all orders
     */
    async findOrdersV2Raw(requestParameters: FindOrdersV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<OrderListV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOrdersV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.exclude_id) {
            queryParameters['exclude_id'] = requestParameters.exclude_id;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.checkout_method) {
            queryParameters['checkout_method'] = requestParameters.checkout_method;
        }

        if (requestParameters.membership_id !== undefined) {
            queryParameters['membership_id'] = requestParameters.membership_id;
        }

        if (requestParameters.contact_id !== undefined) {
            queryParameters['contact_id'] = requestParameters.contact_id;
        }

        if (requestParameters.product_id) {
            queryParameters['product_id'] = requestParameters.product_id;
        }

        if (requestParameters.product_category_id) {
            queryParameters['product_category_id'] = requestParameters.product_category_id;
        }

        if (requestParameters.parent_id) {
            queryParameters['parent_id'] = requestParameters.parent_id;
        }

        if (requestParameters.partially_paid !== undefined) {
            queryParameters['partially_paid'] = requestParameters.partially_paid;
        }

        if (requestParameters.coupon_id) {
            queryParameters['coupon_id'] = requestParameters.coupon_id;
        }

        if (requestParameters.amount_total_lt !== undefined) {
            queryParameters['amount_total_lt'] = requestParameters.amount_total_lt;
        }

        if (requestParameters.amount_total_gt !== undefined) {
            queryParameters['amount_total_gt'] = requestParameters.amount_total_gt;
        }

        if (requestParameters.amount_total_lte !== undefined) {
            queryParameters['amount_total_lte'] = requestParameters.amount_total_lte;
        }

        if (requestParameters.amount_total_gte !== undefined) {
            queryParameters['amount_total_gte'] = requestParameters.amount_total_gte;
        }

        if (requestParameters.created_lt !== undefined) {
            queryParameters['created_lt'] = (requestParameters.created_lt as any).toISOString();
        }

        if (requestParameters.created_gt !== undefined) {
            queryParameters['created_gt'] = (requestParameters.created_gt as any).toISOString();
        }

        if (requestParameters.created_lte !== undefined) {
            queryParameters['created_lte'] = (requestParameters.created_lte as any).toISOString();
        }

        if (requestParameters.created_gte !== undefined) {
            queryParameters['created_gte'] = (requestParameters.created_gte as any).toISOString();
        }

        if (requestParameters.updated_lt !== undefined) {
            queryParameters['updated_lt'] = (requestParameters.updated_lt as any).toISOString();
        }

        if (requestParameters.updated_gt !== undefined) {
            queryParameters['updated_gt'] = (requestParameters.updated_gt as any).toISOString();
        }

        if (requestParameters.updated_lte !== undefined) {
            queryParameters['updated_lte'] = (requestParameters.updated_lte as any).toISOString();
        }

        if (requestParameters.updated_gte !== undefined) {
            queryParameters['updated_gte'] = (requestParameters.updated_gte as any).toISOString();
        }

        if (requestParameters.processed_lt !== undefined) {
            queryParameters['processed_lt'] = (requestParameters.processed_lt as any).toISOString();
        }

        if (requestParameters.processed_gt !== undefined) {
            queryParameters['processed_gt'] = (requestParameters.processed_gt as any).toISOString();
        }

        if (requestParameters.processed_lte !== undefined) {
            queryParameters['processed_lte'] = (requestParameters.processed_lte as any).toISOString();
        }

        if (requestParameters.processed_gte !== undefined) {
            queryParameters['processed_gte'] = (requestParameters.processed_gte as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/orders`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderListV2FromJSON(jsonValue));
    }

    /**
     * List all orders
     */
    async findOrdersV2(requestParameters: FindOrdersV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<OrderListV2> {
        const response = await this.findOrdersV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated List all payments
     */
    async findPaymentsRaw(requestParameters: FindPaymentsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<PaymentList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findPayments.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling findPayments.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/orders/{order_id}/payments`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentListFromJSON(jsonValue));
    }

    /**
     * @deprecated List all payments
     */
    async findPayments(requestParameters: FindPaymentsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<PaymentList> {
        const response = await this.findPaymentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all payments
     */
    async findPaymentsV2Raw(requestParameters: FindPaymentsV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<PaymentList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findPaymentsV2.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling findPaymentsV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/orders/{order_id}/payments`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentListFromJSON(jsonValue));
    }

    /**
     * List all payments
     */
    async findPaymentsV2(requestParameters: FindPaymentsV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<PaymentList> {
        const response = await this.findPaymentsV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Create order quote
     */
    async findQuoteOrderRaw(requestParameters: FindQuoteOrderRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Order>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findQuoteOrder.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling findQuoteOrder.');
        }

        const queryParameters: any = {};

        if (requestParameters.use_account_balance !== undefined) {
            queryParameters['use_account_balance'] = requestParameters.use_account_balance;
        }

        if (requestParameters.checkout_method !== undefined) {
            queryParameters['checkout_method'] = requestParameters.checkout_method;
        }

        if (requestParameters.currency !== undefined) {
            queryParameters['currency'] = requestParameters.currency;
        }

        if (requestParameters.country !== undefined) {
            queryParameters['country'] = requestParameters.country;
        }

        if (requestParameters.expand) {
            queryParameters['expand'] = requestParameters.expand;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/orders/{order_id}/quote`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderFromJSON(jsonValue));
    }

    /**
     * @deprecated Create order quote
     */
    async findQuoteOrder(requestParameters: FindQuoteOrderRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Order> {
        const response = await this.findQuoteOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated List all refunds
     */
    async findRefundsRaw(requestParameters: FindRefundsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<RefundList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findRefunds.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling findRefunds.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.created_lt !== undefined) {
            queryParameters['created_lt'] = (requestParameters.created_lt as any).toISOString();
        }

        if (requestParameters.created_gt !== undefined) {
            queryParameters['created_gt'] = (requestParameters.created_gt as any).toISOString();
        }

        if (requestParameters.created_lte !== undefined) {
            queryParameters['created_lte'] = (requestParameters.created_lte as any).toISOString();
        }

        if (requestParameters.created_gte !== undefined) {
            queryParameters['created_gte'] = (requestParameters.created_gte as any).toISOString();
        }

        if (requestParameters.updated_lt !== undefined) {
            queryParameters['updated_lt'] = (requestParameters.updated_lt as any).toISOString();
        }

        if (requestParameters.updated_gt !== undefined) {
            queryParameters['updated_gt'] = (requestParameters.updated_gt as any).toISOString();
        }

        if (requestParameters.updated_lte !== undefined) {
            queryParameters['updated_lte'] = (requestParameters.updated_lte as any).toISOString();
        }

        if (requestParameters.updated_gte !== undefined) {
            queryParameters['updated_gte'] = (requestParameters.updated_gte as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/orders/{order_id}/refunds`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RefundListFromJSON(jsonValue));
    }

    /**
     * @deprecated List all refunds
     */
    async findRefunds(requestParameters: FindRefundsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<RefundList> {
        const response = await this.findRefundsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all refunds
     */
    async findRefundsV2Raw(requestParameters: FindRefundsV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<RefundListV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findRefundsV2.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling findRefundsV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/orders/{order_id}/refunds`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RefundListV2FromJSON(jsonValue));
    }

    /**
     * List all refunds
     */
    async findRefundsV2(requestParameters: FindRefundsV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<RefundListV2> {
        const response = await this.findRefundsV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Process an order payment
     */
    async processPaymentRaw(requestParameters: ProcessPaymentRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<PaymentResult>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling processPayment.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling processPayment.');
        }

        if (requestParameters.ProcessPaymentParams === null || requestParameters.ProcessPaymentParams === undefined) {
            throw new runtime.RequiredError('ProcessPaymentParams','Required parameter requestParameters.ProcessPaymentParams was null or undefined when calling processPayment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/orders/{order_id}/payments`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProcessPaymentParamsToJSON(requestParameters.ProcessPaymentParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentResultFromJSON(jsonValue));
    }

    /**
     * @deprecated Process an order payment
     */
    async processPayment(requestParameters: ProcessPaymentRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<PaymentResult> {
        const response = await this.processPaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Process an order payment
     */
    async processPaymentV2Raw(requestParameters: ProcessPaymentV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<PaymentResultV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling processPaymentV2.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling processPaymentV2.');
        }

        if (requestParameters.ProcessPaymentParams === null || requestParameters.ProcessPaymentParams === undefined) {
            throw new runtime.RequiredError('ProcessPaymentParams','Required parameter requestParameters.ProcessPaymentParams was null or undefined when calling processPaymentV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/orders/{order_id}/payments`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProcessPaymentParamsToJSON(requestParameters.ProcessPaymentParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentResultV2FromJSON(jsonValue));
    }

    /**
     * Process an order payment
     */
    async processPaymentV2(requestParameters: ProcessPaymentV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<PaymentResultV2> {
        const response = await this.processPaymentV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Refund an order
     */
    async refundRefundRaw(requestParameters: RefundRefundRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Array<Refund>>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling refundRefund.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling refundRefund.');
        }

        if (requestParameters.RefundCreateParams === null || requestParameters.RefundCreateParams === undefined) {
            throw new runtime.RequiredError('RefundCreateParams','Required parameter requestParameters.RefundCreateParams was null or undefined when calling refundRefund.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/orders/{order_id}/refunds`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RefundCreateParamsToJSON(requestParameters.RefundCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RefundFromJSON));
    }

    /**
     * @deprecated Refund an order
     */
    async refundRefund(requestParameters: RefundRefundRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Array<Refund>> {
        const response = await this.refundRefundRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Resend order
     */
    async resendOrderRaw(requestParameters: ResendOrderRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling resendOrder.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling resendOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/orders/{order_id}/resend`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * @deprecated Resend order
     */
    async resendOrder(requestParameters: ResendOrderRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.resendOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resend order
     */
    async resendOrderV2Raw(requestParameters: ResendOrderV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling resendOrderV2.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling resendOrderV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/orders/{order_id}/resend`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Resend order
     */
    async resendOrderV2(requestParameters: ResendOrderV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.resendOrderV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Update order
     */
    async updateOrderRaw(requestParameters: UpdateOrderRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Order>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling updateOrder.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling updateOrder.');
        }

        if (requestParameters.Order === null || requestParameters.Order === undefined) {
            throw new runtime.RequiredError('Order','Required parameter requestParameters.Order was null or undefined when calling updateOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/orders/{order_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrderToJSON(requestParameters.Order),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderFromJSON(jsonValue));
    }

    /**
     * @deprecated Update order
     */
    async updateOrder(requestParameters: UpdateOrderRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Order> {
        const response = await this.updateOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Update order item
     */
    async updateOrderItemRaw(requestParameters: UpdateOrderItemRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<OrderItem>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling updateOrderItem.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling updateOrderItem.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateOrderItem.');
        }

        if (requestParameters.OrderItemUpdateParams === null || requestParameters.OrderItemUpdateParams === undefined) {
            throw new runtime.RequiredError('OrderItemUpdateParams','Required parameter requestParameters.OrderItemUpdateParams was null or undefined when calling updateOrderItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/orders/{order_id}/items/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrderItemUpdateParamsToJSON(requestParameters.OrderItemUpdateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderItemFromJSON(jsonValue));
    }

    /**
     * @deprecated Update order item
     */
    async updateOrderItem(requestParameters: UpdateOrderItemRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<OrderItem> {
        const response = await this.updateOrderItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update order item
     */
    async updateOrderItemV2Raw(requestParameters: UpdateOrderItemV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<OrderItemV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling updateOrderItemV2.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling updateOrderItemV2.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateOrderItemV2.');
        }

        if (requestParameters.OrderItemUpdateParamsV2 === null || requestParameters.OrderItemUpdateParamsV2 === undefined) {
            throw new runtime.RequiredError('OrderItemUpdateParamsV2','Required parameter requestParameters.OrderItemUpdateParamsV2 was null or undefined when calling updateOrderItemV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/orders/{order_id}/items/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrderItemUpdateParamsV2ToJSON(requestParameters.OrderItemUpdateParamsV2),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderItemV2FromJSON(jsonValue));
    }

    /**
     * Update order item
     */
    async updateOrderItemV2(requestParameters: UpdateOrderItemV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<OrderItemV2> {
        const response = await this.updateOrderItemV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update order
     */
    async updateOrderV2Raw(requestParameters: UpdateOrderV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<OrderV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling updateOrderV2.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling updateOrderV2.');
        }

        if (requestParameters.OrderUpdateParams === null || requestParameters.OrderUpdateParams === undefined) {
            throw new runtime.RequiredError('OrderUpdateParams','Required parameter requestParameters.OrderUpdateParams was null or undefined when calling updateOrderV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/orders/{order_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrderUpdateParamsToJSON(requestParameters.OrderUpdateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderV2FromJSON(jsonValue));
    }

    /**
     * Update order
     */
    async updateOrderV2(requestParameters: UpdateOrderV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<OrderV2> {
        const response = await this.updateOrderV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Update refund
     */
    async updateRefundRaw(requestParameters: UpdateRefundRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Refund>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling updateRefund.');
        }

        if (requestParameters.refund_id === null || requestParameters.refund_id === undefined) {
            throw new runtime.RequiredError('refund_id','Required parameter requestParameters.refund_id was null or undefined when calling updateRefund.');
        }

        if (requestParameters.RefundUpdateParams === null || requestParameters.RefundUpdateParams === undefined) {
            throw new runtime.RequiredError('RefundUpdateParams','Required parameter requestParameters.RefundUpdateParams was null or undefined when calling updateRefund.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/orders/{order_id}/refunds/{refund_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"refund_id"}}`, encodeURIComponent(String(requestParameters.refund_id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RefundUpdateParamsToJSON(requestParameters.RefundUpdateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RefundFromJSON(jsonValue));
    }

    /**
     * @deprecated Update refund
     */
    async updateRefund(requestParameters: UpdateRefundRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Refund> {
        const response = await this.updateRefundRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update refund
     */
    async updateRefundV2Raw(requestParameters: UpdateRefundV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<RefundV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling updateRefundV2.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling updateRefundV2.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateRefundV2.');
        }

        if (requestParameters.RefundUpdateParamsV2 === null || requestParameters.RefundUpdateParamsV2 === undefined) {
            throw new runtime.RequiredError('RefundUpdateParamsV2','Required parameter requestParameters.RefundUpdateParamsV2 was null or undefined when calling updateRefundV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/orders/{order_id}/refunds/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RefundUpdateParamsV2ToJSON(requestParameters.RefundUpdateParamsV2),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RefundV2FromJSON(jsonValue));
    }

    /**
     * Update refund
     */
    async updateRefundV2(requestParameters: UpdateRefundV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<RefundV2> {
        const response = await this.updateRefundV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
